function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m221.99 280.48c9.664 0 17.516-7.889 17.516-17.563 0-9.653-7.852-17.487-17.516-17.487l-79.361-58.371 61.844 76.985c0.574 9.164 8.209 16.436 17.517 16.436z"
}), React.createElement("rect", {
  x: 127.01,
  y: 332.2,
  width: 174.93,
  height: 41.513
}), React.createElement("path", {
  d: "m366.13 118.06c-40.51-40.509-94.369-62.818-151.66-62.818-57.288 0-111.15 22.309-151.66 62.818s-62.817 94.368-62.817 151.66c0 36.99 9.319 72.539 26.816 104h40.086l29.319-16.929-12.948-22.428-37.7 21.768c-13.319-25.932-20.843-55.307-20.843-86.408 0-5.504 0.25-10.951 0.711-16.338l44.952 7.926 4.497-25.504-45.481-8.019c8.127-35.883 26.451-67.937 51.755-92.948l30.815 36.725 19.839-16.646-31.049-37.002c28.471-21.379 63.128-34.938 100.76-37.485v49.117h25.896v-49.117c37.629 2.549 72.286 16.107 100.76 37.486l-31.05 37.001 19.838 16.646 30.816-36.726c25.303 25.012 43.627 57.066 51.754 92.948l-45.48 8.021 4.498 25.502 44.949-7.927c0.461 5.388 0.711 10.834 0.711 16.338 0 31.103-7.521 60.479-20.842 86.409l-37.701-21.766-12.947 22.427 29.318 16.927h40.088c17.498-31.458 26.816-67.007 26.816-104 1e-3 -57.287-22.31-111.15-62.818-151.65z"
}));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 428.948 428.948",
    viewBox: "0 0 428.95 428.95",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.f7fd2ef9.svg";
export { ForwardRef as ReactComponent };